module.exports = "/public/images/5bac6d6bba514773aa4131d13e0d337c.svg";